var _rect;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRateMaster = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "currentColor",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.83 0 0 0.83 12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.5 6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-18.5, -18.5)",
    d: "M 13.5 18.5 C 13.5 21.261423749153966 15.738576250846034 23.5 18.5 23.5 C 21.261423749153966 23.5 23.5 21.261423749153966 23.5 18.5 C 23.5 15.738576250846034 21.261423749153966 13.5 18.5 13.5 C 15.738576250846034 13.5 13.5 15.738576250846032 13.5 18.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.5 9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-18.5, -21)",
    d: "M 18.5 20.5 L 18.5 21.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.5 4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-18.5, -16)",
    d: "M 18.5 15.5 L 18.5 16.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.5 6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-18.5, -18.5)",
    d: "M 16.5 20.5 L 19.5 20.5 C 20.052284749830793 20.5 20.5 20.052284749830793 20.5 19.5 C 20.5 18.947715250169207 20.052284749830793 18.5 19.5 18.5 L 17.5 18.5 C 16.947715250169207 18.5 16.5 18.052284749830793 16.5 17.5 C 16.5 16.947715250169207 16.947715250169207 16.5 17.5 16.5 L 20.5 16.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-6.5, -12.5)",
    d: "M 0.5 15.5 C 0.5 12.186291501015239 3.1862915010152393 9.5 6.5 9.5 C 9.813708498984761 9.5 12.5 12.186291501015237 12.5 15.499999999999998 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.5 -7.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-6.5, -4.25)",
    d: "M 2.75 4.25 C 2.75 6.3210678118654755 4.4289321881345245 8 6.5 8 C 8.571067811865476 8 10.25 6.3210678118654755 10.25 4.25 C 10.25 2.1789321881345245 8.571067811865476 0.5 6.5 0.5 C 4.4289321881345245 0.5 2.75 2.178932188134524 2.75 4.249999999999999 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4 -7.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16, -4.25)",
    d: "M 12.25 4.25 C 12.25 6.3210678118654755 13.928932188134524 8 16 8 C 18.071067811865476 8 19.75 6.3210678118654755 19.75 4.25 C 19.75 2.1789321881345245 18.071067811865476 0.5 16 0.5 C 13.928932188134524 0.5 12.25 2.178932188134524 12.25 4.249999999999999 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.24 -1.95)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16.23, -10.05)",
    d: "M 19.47 10.605 C 17.558148078580263 9.247992565402201 15.031030310382079 9.128862593331034 12.999999999999998 10.3",
    strokeLinecap: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRateMaster, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rateMaster.e9a09705.svg";
export { ForwardRef as ReactComponent };